import React from "react";

const Health = () => {
  return <p>Up</p>;
};

export default Health;
